/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-14 09:51:40
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-14 10:18:59
 */
import CryptoJS from 'crypto-js';

const parse = (string) => {   
    return CryptoJS.enc.Utf8.parse(string);   
}

export default { // 加密
  /**
   * @description: 加密
   * @param {*} word
   * @param {*} keyStr
   */
   encryption(word, keyStr, iv) {
    return CryptoJS.AES.encrypt(parse(word), parse(keyStr), {   
        iv: parse(iv),   
        mode: CryptoJS.mode.CBC,   
        padding: CryptoJS.pad.Pkcs7   
        }).toString();
  },

  /**
   * @description: 解密
   * @param {*} word
   * @param {*} keyStr
   */
   decrypt(word, keyStr, iv) {
    return CryptoJS.AES.decrypt(word, parse(keyStr),{   
        iv: parse(iv),   
        mode: CryptoJS.mode.CBC,   
        padding: CryptoJS.pad.Pkcs7   
        }).toString(CryptoJS.enc.Utf8); 
    }
}